import videoRation from './video-ration';

const handleYoutubeVideo = ($video) => {
    if ($video.length) {
        const $videoInner = $video.find('.video__inner');

        const player = new YT.Player($videoInner.attr('id'), {
            videoId: $videoInner.data('video-id'),
            playerVars: {
                'contols': 0,
                'rel': 0,
                'fs': 0,
                'autoplay': 0,
                'showinfo': 0,
                'disablekb': 1,
                'loop': 1
            },
            events: {
                'onReady': function() {
                    $video.addClass('video--is-play');

                    videoRation($video);

                    player.mute()
                        .playVideo();
                },
                'onStateChange': function(event) {
                    if ( event.data == YT.PlayerState.ENDED ) {
                        player.mute()
                            .playVideo();
                    }
                }
            }
        });


        $(window).on('resize', function() {
            videoRation($video);
        });
    }
}

export default handleYoutubeVideo;
